'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import formatCurrencyWithCode from '../utils/formatCurrencyWithCode';
import NumberTypes from '../constants/NumberTypes';
export default class FormattedNumber extends Component {
  render() {
    const NUMBER_FORMATTERS = {
      [NumberTypes.DECIMAL]: I18n.formatNumber,
      [NumberTypes.CURRENCY]: I18n.formatCurrency,
      [NumberTypes.PERCENTAGE]: I18n.formatPercentage
    };

    const _this$props = this.props,
          {
      abbreviate,
      abbreviateThreshold,
      value,
      style,
      simplifyCurrency,
      stripInsignificantZeros,
      useCurrencyCode
    } = _this$props,
          options = _objectWithoutPropertiesLoose(_this$props, ["abbreviate", "abbreviateThreshold", "value", "style", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"]);

    const numberFormatter = NUMBER_FORMATTERS[style];

    if (style === NumberTypes.CURRENCY) {
      console.warn('Using FormattedNumber with the currency style is deprecated. Please use FormattedCurrency instead.');
    }

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (useCurrencyCode) {
      options.unit = '';
    }

    if (stripInsignificantZeros === false) {
      options.strip_insignificant_zeros = false;
    } else {
      options.strip_insignificant_zeros = true;
    }

    const wrapperAttributes = {};

    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = numberFormatter(value, options);
      options.abbreviate = true;
      options.precision = 0;
    }

    const formattedNumber = numberFormatter(value, options);
    const numberToRender = useCurrencyCode ? formatCurrencyWithCode(formattedNumber, options.currencyCode) : formattedNumber;
    return /*#__PURE__*/_jsx("span", Object.assign({}, wrapperAttributes, {
      children: numberToRender
    }));
  }

}
FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.propTypes = {
  abbreviate: PropTypes.bool,
  abbreviateThreshold: PropTypes.number,
  currencyCode: PropTypes.string,
  precision: PropTypes.number,
  simplifyCurrency: PropTypes.bool,
  stripInsignificantZeros: PropTypes.bool,
  style: PropTypes.oneOf(Object.keys(NumberTypes).map(key => NumberTypes[key])),
  unit: PropTypes.string,
  useCurrencyCode: PropTypes.bool,
  value: PropTypes.number.isRequired
};
FormattedNumber.defaultProps = {
  simplifyCurrency: false,
  stripInsignificantZeros: true,
  style: NumberTypes.DECIMAL
};